import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Rect, { width: "20", height: "12", x: "2", y: "6", rx: "2", stroke: `${color}` })
    }
  );
};
Icon.displayName = "RectangleHorizontal";
const RectangleHorizontal = memo(themed(Icon));
export {
  RectangleHorizontal
};
//# sourceMappingURL=rectangle-horizontal.js.map
